// src/ecrans/portes-g3.js — LIRE UNE PORTE DU SERVEUR, pour les écrans
// orchestrateur et Réglages (P-4.24, P-3.48). Une lecture ne rend jamais une
// liste vide à la place d'une panne : { etat: "lecture" | "ok" | "echec" }.
//
// ⚠️ DETTE À FONDRE : #1760 apporte src/ecrans/portes.js, qui fait la même
// chose et n'est pas fusionnée. À sa fusion, ces écrans passent à portes.js et
// ce fichier disparaît (une seule copie, règle 79).

import { useCallback, useEffect, useState } from "react";
import { supabase } from "../supabase";

export const EN_LECTURE = Object.freeze({ etat: "lecture" });

/** Le message d'une lecture ratée : un statut, jamais une donnée. */
export function motifDe(statut, json) {
  if (statut === 401) return "Session expirée : reconnectez-vous.";
  if (statut === 403) return "Lecture refusée pour ce compte.";
  if (json && json.code === "lecture_impossible") return "Le serveur n'a pas pu lire ces données.";
  return statut ? `Lecture impossible (erreur ${statut}).` : "Lecture impossible.";
}

/**
 * Appelle une porte, ne lève jamais. `ok: true` est exigé, sauf pour les
 * portes plus anciennes (`sansOk`), où seul `ok: false` reste un échec.
 */
export async function lirePorteEcran(action, { sansOk = false, fetchFn, session } = {}) {
  const envoyer = fetchFn || fetch;
  let jeton = null;
  try {
    const r = await (session ? session() : supabase.auth.getSession());
    jeton = r?.data?.session?.access_token || null;
  } catch (e) {
    return { etat: "echec", motif: "Session illisible : reconnectez-vous." };
  }
  if (!jeton) return { etat: "echec", motif: "Session expirée : reconnectez-vous." };
  let res;
  try {
    res = await envoyer("/api/beds24-mapping", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${jeton}` },
      body: JSON.stringify({ action }),
    });
  } catch (e) {
    return { etat: "echec", motif: "Connexion impossible. Réessayez." };
  }
  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    json = null;
  }
  if (!res.ok) return { etat: "echec", motif: motifDe(res.status, json) };
  const objet = json && typeof json === "object" && !Array.isArray(json);
  if (!objet || json.ok === false || (json.ok !== true && !sansOk))
    return { etat: "echec", motif: "Réponse du serveur illisible." };
  return { etat: "ok", data: json };
}

/** Lit une porte au montage, relit sur `relire()`. */
export function useLecturePorte(action, opts) {
  const [lecture, setLecture] = useState(EN_LECTURE);
  const [tour, setTour] = useState(0);
  const sansOk = Boolean(opts && opts.sansOk);
  useEffect(() => {
    if (!action) return undefined;
    let actif = true;
    // Une relecture garde ce qui est affiché jusqu'à la réponse.
    setLecture((l) => (l.etat === "ok" ? l : EN_LECTURE));
    lirePorteEcran(action, { sansOk }).then((r) => {
      if (actif) setLecture(r);
    });
    return () => {
      actif = false;
    };
  }, [action, tour, sansOk]);
  const relire = useCallback(() => setTour((t) => t + 1), []);
  return [lecture, relire];
}
